import React, { useState, FC, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@material-ui/core";
import moment from "moment/moment";
import {useSnackbar} from "notistack";
import {colorInputBorder} from "../../../Constants/theme";
import {patchAppointment} from "../../../redux/appointment/appointment.actions";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";

const useStyles = makeStyles({
    dialog: {
        padding: "20px"
    },
    dialogTitle: {
        fontSize: "24px",
        fontWeight: "bold"
    },
    dialogMessage: {
        padding: "10px 0",
        fontSize: "19px",
        letterSpacing: "-0.078px"
    },
    button: {
        padding: "12px 32px",
        color: colorInputBorder,
        border: `1px solid ${colorInputBorder}`
    }
});

// eslint-disable-next-line react/prop-types
const CancelAppointment = ({isOpen, setOpenDialog, item})  => {
    const classes = useStyles();
    const [dialogMessage, setDialogMessage] = useState("");
    const cancelMessage = "Are you sure you wish to cancel the appointment?";
    const cancelWithoutRefundMessage = "I recognize that I am cancelling my appointment with less than 12 hours notice and accept that I will not receive a refund.";
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);

    const handleClose = () => {
        setOpenDialog(false);
    };

    useEffect(() => {
        setOpenDialog(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if(item) {
            let timeNow = moment(), scheduledTime = moment(item.scheduledDate);
            let difference = scheduledTime.diff(timeNow, "hours");
            if(user.role === "OWNER" && difference < 12) {
                setDialogMessage(cancelWithoutRefundMessage);
            } else {
                setDialogMessage(cancelMessage);
            }
        }
    }, [item]);

    const handleCancel = async () => {
        try {
            await dispatch(patchAppointment(item.id, {
                status: "CANCELLED"
            }));
        } catch (error) {
            enqueueSnackbar(error, {variant: "error"});
        } finally {
            setOpenDialog(false);
            window.location.reload();
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            disableEnforceFocus
            classes={{paper: classes.dialog}}
        >
            <DialogTitle color="primary" classes={{root: classes.dialogTitle}}>
                <Typography variant="h4">
					Cancellation confirmation
                </Typography>
            </DialogTitle>
            {	item &&
				<>
				    <DialogContent>
				        <DialogContentText classes={{root: classes.dialogMessage}}>
				            {dialogMessage}
				        </DialogContentText>
				    </DialogContent>
				    <DialogActions>
				        <Button type="button" onClick={handleClose} autoFocus variant="contained" classes={{root: classes.button}}>
							Don&apos;t cancel
				        </Button>
				        <Button type="button" onClick={handleCancel} color="primary" variant="contained" style={{padding: "12px 32px"}}>
							Yes, cancel
				        </Button>
				    </DialogActions>
				</>
            }
        </Dialog>
    );
};

export default CancelAppointment;
